import {toast} from 'react-toastify'
import {TOAST_SETTING, UNAUTHORIZED_REASON} from '../../Common/Constants'
import {AxiosError} from 'axios'

export const ErrorHandler = (error: any) => {
  if (error && error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    // console.log(error.response.data);
    // console.log(error.response.status);
    // console.log(error.response.headers);

    if (error.response.status === 401 && error.response.statusText !== UNAUTHORIZED_REASON.PASSWORD_EXPIRED) {
      window.location.href = '/error/401'
    } else if (error.response.status === 404) {
      window.location.href = '/error/404'
    } else if (error.response.status === 500) {
      window.location.href = '/error/500'
    } else {
      toast.error(
        <>
          <b>
            {error.response.status} {error.response.statusText}
          </b>
          <br />
          {error.response.data.Message}
        </>,
        TOAST_SETTING.ERROR
      )
    }
  } else if (error && error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    // console.log(error.request);

    // 18112025 (Peter) - error.request is an object, direct render will cause render error (cannot render object as react element)
    if (typeof error.request === 'string') {
      toast.error(<>{error.request}</>, TOAST_SETTING.ERROR)
    } else {
      toast.error(
        <>
          <b>Connection Error</b>
          <br />A network issue occurred. Please try again.
        </>,
        TOAST_SETTING.ERROR
      )
    }
  } else if (error && error.message) {
    // Something happened in setting up the request that triggered an Error
    // console.log('Error', error.message);

    toast.error(<>{error.message}</>, TOAST_SETTING.ERROR)
  } else {
    // Error is undefined

    toast.error(
      <>
        <b>Unusual Error</b>
        <br />
        Please contact IT Administrator.
      </>,
      TOAST_SETTING.ERROR
    )
  }
}
